import {
	SET_PROFILE_MODAL_VISIBILITY,
	SET_PROFILE_AUTHENTICATION,
} from '../actions/setProfile'

const initialState = {
	isProfileAuthenticated: false,
	isProfileModalVisible: false
}

export default function setProfileReducers(state = initialState, action) {
	switch(action.type) {
		case SET_PROFILE_AUTHENTICATION:
			return {
				...state,
				isProfileAuthenticated: action.payload,
			}
		case SET_PROFILE_MODAL_VISIBILITY:
			return {
				...state,
				isProfileModalVisible: action.payload
			}

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/setProfileReducers.js